<script>
export default {
    props: {
        product: {
            required: true,
        },
        scheduleDate: {
            required: true,
        },
    },
    data() {
        return {
            currentProduct: null,
            form: new SparkForm({
                base_price: null,
                units_posted_remaining: null,
            }),
        };
    },
    computed: {
        adjustedPrice() {
            let unitPrice = _.toNumber(this.form.base_price);
            return this.priceModifier && unitPrice ? unitPrice + this.priceModifier.multiplier * unitPrice : unitPrice;
        },
        priceModifier() {
            return _.get(this.scheduleDate, 'price_modifier');
        },
        units_posted_remaining: {
            get() {
                return this.form.units_posted_remaining < 0 ? 0 : this.form.units_posted_remaining;
            },
            set(newVal) {
                this.form.units_posted_remaining = newVal;
            },
        },
    },
    methods: {
        saveProduct() {
            Spark.put(`/api/team/products/${this.product.id}`, this.form).then((response) => {
                Bus.$emit('postedAssetUpdated', response);
                $(this.$refs.dropForm).dropdown('toggle');
            });
        },
        cancelProduct() {
            this.currentProduct = this.product;
            this.form.base_price = _.get(this.currentProduct, 'base_price');
            this.form.units_posted_remaining = _.get(this.currentProduct, 'units_posted_remaining');
            this.reloadComponent();
        },
    },
    watch: {
        product: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.currentProduct = newVal;
                this.form.base_price = _.get(newVal, 'base_price');
                this.form.units_posted_remaining = _.get(newVal, 'units_posted_remaining');
            },
        },
    },
};
</script>
